(function () {
    try {
      var debug = 0;
      var variation_name = "";
      var $;
      const testId = 'AB-033';
      const variantId = 'variant-1';
      const vids = {
        '0': 'https://cdn.shopify.com/videos/c/o/v/90544b0238f541ecb08feb84507eb523.mp4',
        '1': 'https://cdn.shopify.com/videos/c/o/v/53f555d53b3a4a02ba44759b3599180c.mp4',
        '2': 'https://cdn.shopify.com/videos/c/o/v/4d5cfcbce4c54d698bad5f6f61ea89f4.mp4',
      };
  
      function waitForElement(selector, trigger, delayInterval, delayTimeout) {
        var interval = setInterval(function () {
          if (
            document &&
            document.querySelector(selector) &&
            document.querySelectorAll(selector).length > 0
          ) {
            clearInterval(interval);
            trigger();
          }
        }, delayInterval);
        setTimeout(function () {
          clearInterval(interval);
        }, delayTimeout);
      }
  
      function live(selector, event, callback, context) {
        function addEvent(el, type, handler) {
          if (el.attachEvent) el.attachEvent('on' + type, handler);
          else el.addEventListener(type, handler);
        }
        this.Element &&
          (function (ElementPrototype) {
            ElementPrototype.matches =
              ElementPrototype.matches ||
              ElementPrototype.matchesSelector ||
              ElementPrototype.webkitMatchesSelector ||
              ElementPrototype.msMatchesSelector ||
              function (selector) {
                var node = this,
                  nodes = (node.parentNode || node.document).querySelectorAll(selector),
                  i = -1;
                while (nodes[++i] && nodes[i] != node);
                return !!nodes[i];
              };
          })(Element.prototype);
        function live(selector, event, callback, context) {
          addEvent(context || document, event, function (e) {
            var found,
              el = e.target || e.srcElement;
            while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
            if (found) callback.call(el, e);
          });
        }
        live(selector, event, callback, context);
      }
  
      let bannerHTML = `<div class="eg-herosection">
      <div class="egcontainer">
          <div class="eg-left">
              <div class="eg-trustpilot">
                  <div class="eg-trust-image"><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/trust_1.png?v=1730965909"></div>
                  <div class="eg-trust-image"><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/star_1.png?v=1730965936"></div>
                  <span>TrustScore 4.8 | 1,437 reviews</span>
              </div>
              <div class="eg-heading">Built For The Working Man.</div>
              <div class="eg-bulletpoints">
                  <ul>
                      <li><span><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/bulletpoint_icon_94cbdf12-eaf4-475e-8e11-ea1486f294f6.svg?v=1730733980"></span>Rugged & Indestructible</li>
                      <li><span><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/bulletpoint_icon_94cbdf12-eaf4-475e-8e11-ea1486f294f6.svg?v=1730733980"></span>IP69 Dust & Waterproof</li>
                      <li><span><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/bulletpoint_icon_94cbdf12-eaf4-475e-8e11-ea1486f294f6.svg?v=1730733980"></span>Worn Daily by 50,000+ Workers</li>
                      <li><span><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/bulletpoint_icon_94cbdf12-eaf4-475e-8e11-ea1486f294f6.svg?v=1730733980"></span><p class="eg-tested"><b class="eg-color">-30°C</b> Tested - Canadian Winter Approved</p></li>
                  </ul>
              </div>
              <div class="eg-button">
                  <div class="eg-watch_image eg-watchmob_image"><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/hero-image.png?v=1736161641"></div>
                  <a class="eg-shop-now" href="https://njord-gear.com/collections/njord-gear-crate">Shop Now
                    <img class="eg-right-icon" src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/icon.png?v=1730733980">
                  </a>
                  <div class="eg-logos">
                      <p><span><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/guarantee_img.svg?v=1730733980"></span>Money-Back Guarantee</p>
                      <p><span><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/shipping_image.svg?v=1730733980"></span>Free 3-Day Shipping to US/CA</p>
                  </div>
              </div>
          </div>
          <div class="eg-right">
              <div class="eg-watch_image"><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/hero-image.png?v=1736161641"></div>
              <div class="eg-customersay">
                  <h2 class="eg-heading">What Our <br> Customers Say</h2>
                  <div class="eg-video_section">
                  </div>
              </div>
          </div>
      </div>
      </div>`;
 
      function init() {
        if (!document.querySelector('.eg-herosection')) {
          document.body.classList.add('EG-AB033');
          let targetElem = document.querySelector('#MainContent > div:first-of-type');
          targetElem.innerHTML = bannerHTML;
        }
  
        if (window.innerWidth < 767) {
          document.querySelector('.eg-herosection').insertAdjacentElement('afterend', document.querySelector('.eg-herosection .eg-right .eg-customersay'))
        }
        addGifs();
        addModal();
  
        live('.eg-trustpilot', 'click', function () {
          var trustSection = document.querySelector('.index-section > .section--divider');
          trustSection.scrollIntoView({ behavior: 'smooth' });
        });
      }
  
      function addModal() {
        const modalHtml = `
        <div id="${testId}-modal">
          <div class="${testId}-modal_inner">
            <button id="${testId}-close">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M0.8 8L0 7.2L3.2 4L0 0.8L0.8 0L4 3.2L7.2 0L8 0.8L4.8 4L8 7.2L7.2 8L4 4.8L0.8 8Z" fill="black"/></svg>
            </button>
            <div class="${testId}-modal-content"></div>
          </div>
        </div>`;
  
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        document.getElementById(`${testId}-modal`).addEventListener('click', e => {
          const isOverlay = e.target.matches(`#${testId}-modal`);
          const isCloseBtn = e.target.matches(`#${testId}-close, #${testId}-close *`);
          const video = document.querySelector(`.${testId}-modal-content video`);
  
          if (isOverlay || isCloseBtn && video) {
            video.pause();
            video.src = "";
            video.load();
            video.remove();
            document.body.classList.remove(`${testId}-modal--visible`);
          }
        });
      }
  
      function addGifs() {
        const gifs = ['https://cdn.shopify.com/videos/c/o/v/90544b0238f541ecb08feb84507eb523.mp4', 'https://cdn.shopify.com/videos/c/o/v/53f555d53b3a4a02ba44759b3599180c.mp4', 'https://cdn.shopify.com/videos/c/o/v/4d5cfcbce4c54d698bad5f6f61ea89f4.mp4'];
        const html = `
        <div id="${testId}-gifs">
          <div class="${testId}-gifs-inner swiper">
            <div class="swiper-wrapper">
              ${gifs.map((el, idx) => `<div class="${testId}-img_wrapper swiper-slide" data-idx="${idx}"><video src="${el}" autoplay muted loop playsinline></video></div>`).join('')}
            </div>
          </div>
        </div>`;
  
        document.querySelector('.eg-video_section').innerHTML = html;
        document.querySelectorAll(`#${testId}-gifs .swiper-slide`).forEach(el => {
          el.addEventListener('click', () => {
            const idx = el.dataset.idx;
            const modalContentContainer = document.querySelector(`.${testId}-modal-content`);
  
            const html = `<span class="loader"></span><video src="${vids[idx]}" preload="auto" playsinline></video>`;
  
            modalContentContainer.innerHTML = html;
            modalContentContainer.parentElement.classList.add(`${testId}-loading`);
            document.body.classList.add(`${testId}-modal--visible`);
  
            document.querySelector(`#${testId}-modal video`).addEventListener('loadedmetadata', e => {
              if (document.body.classList.contains(`${testId}-modal--visible`)) {
                e.target.previousElementSibling && e.target.previousElementSibling.remove();
                modalContentContainer.parentElement.classList.remove(`${testId}-loading`);
                e.target.play();
              }
            });
            document.querySelector(`#${testId}-modal video`).addEventListener('ended', e => {
              e.target.remove();
              document.body.classList.remove(`${testId}-modal--visible`);
            });
          });
        });
      }
  
      if (window.location.pathname === '/' || window.location.pathname === '/en-ca') {
        waitForElement('#MainContent > div:first-of-type', init, 50, 15000);
      }
    } catch (e) {
      if (debug) console.log(e, "error in Test" + variation_name);
    }
})();